import { createGlobalState } from 'react-use';

import { AppointmentAdvancePayment } from '@dreryk/egabinet-appointment-advance-payment-frontend-api';

type PrescriptionVisitAdvancePaymentGlobalStateMap = Map<number, AppointmentAdvancePayment>;

const useGlobalState = createGlobalState<PrescriptionVisitAdvancePaymentGlobalStateMap>(new Map());

type UsePrescriptionVisitAdvancePaymentGlobalStateReturnFn = {
   getAdvancePayment: (appointmentId: number) => AppointmentAdvancePayment | null;
   updateAdvancePayment: (state: PrescriptionVisitAdvancePaymentGlobalStateMap) => void;
   resetAdvancePayment: VoidFunction;
};

export const usePrescriptionVisitAdvancePaymentGlobalState = (): UsePrescriptionVisitAdvancePaymentGlobalStateReturnFn => {
   const [globalState, setGlobalState] = useGlobalState();

   const getAdvancePayment = (appointmentId: number): AppointmentAdvancePayment | null => {
      return globalState.get(appointmentId) ?? null;
   };

   const resetAdvancePayment = (): void => {
      setGlobalState(new Map());
   };

   return {
      getAdvancePayment: getAdvancePayment,
      updateAdvancePayment: setGlobalState,
      resetAdvancePayment: resetAdvancePayment,
   };
};
